export default {"src":"/_next/static/media/close-teal.e500dfca.svg","height":8,"width":8};